var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageActions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 51,
    height: 51,
    rx: 25.5,
    stroke: "#E3E8E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 23.375C27.0192 23.375 27.5267 23.529 27.9584 23.8174C28.3901 24.1058 28.7265 24.5158 28.9252 24.9955C29.1239 25.4751 29.1758 26.0029 29.0746 26.5121C28.9733 27.0213 28.7233 27.489 28.3562 27.8562C27.989 28.2233 27.5213 28.4733 27.0121 28.5746C26.5029 28.6758 25.9751 28.6239 25.4955 28.4252C25.0158 28.2265 24.6058 27.89 24.3174 27.4584C24.029 27.0267 23.875 26.5192 23.875 26C23.875 25.3038 24.1516 24.6361 24.6438 24.1438C25.1361 23.6516 25.8038 23.375 26.5 23.375ZM21.625 26C21.625 25.4808 21.471 24.9733 21.1826 24.5416C20.8942 24.1099 20.4842 23.7735 20.0045 23.5748C19.5249 23.3761 18.9971 23.3242 18.4879 23.4254C17.9787 23.5267 17.511 23.7767 17.1438 24.1438C16.7767 24.511 16.5267 24.9787 16.4254 25.4879C16.3242 25.9971 16.3761 26.5249 16.5748 27.0045C16.7735 27.4842 17.11 27.8942 17.5416 28.1826C17.9733 28.471 18.4808 28.625 19 28.625C19.6962 28.625 20.3639 28.3484 20.8562 27.8562C21.3484 27.3639 21.625 26.6962 21.625 26ZM31.375 26C31.375 26.5192 31.529 27.0267 31.8174 27.4584C32.1058 27.89 32.5158 28.2265 32.9955 28.4252C33.4751 28.6239 34.0029 28.6758 34.5121 28.5746C35.0213 28.4733 35.489 28.2233 35.8562 27.8562C36.2233 27.489 36.4733 27.0213 36.5746 26.5121C36.6758 26.0029 36.6239 25.4751 36.4252 24.9955C36.2265 24.5158 35.8901 24.1058 35.4584 23.8174C35.0267 23.529 34.5192 23.375 34 23.375C33.3038 23.375 32.6361 23.6516 32.1438 24.1438C31.6516 24.6361 31.375 25.3038 31.375 26Z",
    fill: "#ACB9B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageActions);
export default __webpack_public_path__ + "static/media/message-actions.46f2ece8ca2620472a6080079585453b.svg";
export { ForwardRef as ReactComponent };